import { useSearchPersist } from '@/components/DataGrid/hooks/useSearchPersist';
import { MasterNameKaseOrganizationForm } from '@/layouts/TabLayout/MasterNames/components/MasterNameKaseOrganizationForm';

import MasterIndexOrganizationBase from './MasterIndexOrganizationBase';

const MasterIndexOrganizationForm = () => {
  const { navigateWithSearch } = useSearchPersist();

  return (
    <MasterIndexOrganizationBase>
      <MasterNameKaseOrganizationForm
        onGoBack={() => navigateWithSearch('/master-index/organizations')}
        hideHeader={true}
        isMasterIndex={true}
      />
    </MasterIndexOrganizationBase>
  );
};

export default MasterIndexOrganizationForm;
